import { useEffect, useState } from 'react';
import './App.css';
import GreenhouseBackground from './GreenhouseBackground';
import LoginScreen from './LoginScreen';
import HomeScreen from './HomeScreen';
import MeetingScreen from './MeetingScreen';
import ConferenceScreen from './ConferenceScreen';
import HocchokenHubScreen from './HocchokenHubScreen';
import HocchokenScheduleScreen from './HocchokenScheduleScreen';
import HocchokenCasesScreen from './HocchokenCasesScreen';
import KanriEditScreen from './KanriEditScreen';
import KanriCodeScreen from './KanriCodeScreen';
import ReportsHubScreen from './ReportsHubScreen';
import ShutchoScreen from './ShutchoScreen';
import { getStoredSiteToken } from './authToken';
import { setUnauthorizedHandler } from './api';

// LINEのリッチメニュー等から ?go=hocchoken のようなURLで直接特定の画面を開けるように
// する。隠しページ(管理者編集/管理者コード)はここに含めない——ロック画面より前に
// 存在が分かってしまう入口を増やしたくないため、トップページ隅の小さいリンクからのみ
// 入れる設計のままにする。
const DEEP_LINK_SCREENS = new Set([
  'meeting', 'conference', 'reports', 'reports-shutcho',
  'hocchoken', 'hocchoken-schedule', 'hocchoken-cases',
]);
function getDeepLinkTarget() {
  try {
    const target = new URLSearchParams(window.location.search).get('go');
    return DEEP_LINK_SCREENS.has(target) ? target : null;
  } catch {
    return null;
  }
}

export default function App() {
  // 保存済みの入場証がまだ有効そうなら、ログイン画面を飛ばす。
  // 有効な?goがあれば、ホームではなくそこへ直接開く。
  const [screen, setScreen] = useState(() => {
    if (!getStoredSiteToken()) return 'login';
    return getDeepLinkTarget() || 'home';
  });

  useEffect(() => {
    // どの画面からでも、入場証が失効したと分かったらログイン画面へ戻す。
    setUnauthorizedHandler(() => setScreen('login'));
  }, []);

  return (
    <div className="app-bg">
      <GreenhouseBackground />
      {screen === 'login' && <LoginScreen onEnter={() => setScreen(getDeepLinkTarget() || 'home')} />}
      {screen === 'home' && <HomeScreen onNavigate={setScreen} />}
      {screen === 'meeting' && <MeetingScreen onBack={() => setScreen('home')} />}
      {screen === 'conference' && <ConferenceScreen onBack={() => setScreen('home')} />}
      {screen === 'hocchoken' && <HocchokenHubScreen onNavigate={setScreen} onBack={() => setScreen('home')} />}
      {screen === 'hocchoken-schedule' && <HocchokenScheduleScreen onBack={() => setScreen('hocchoken')} />}
      {screen === 'hocchoken-cases' && <HocchokenCasesScreen onBack={() => setScreen('hocchoken')} />}
      {screen === 'kanri-edit' && <KanriEditScreen onBack={() => setScreen('home')} />}
      {screen === 'kanri-code' && <KanriCodeScreen onBack={() => setScreen('home')} />}
      {screen === 'reports' && <ReportsHubScreen onNavigate={setScreen} onBack={() => setScreen('home')} />}
      {screen === 'reports-shutcho' && <ShutchoScreen onBack={() => setScreen('reports')} />}
    </div>
  );
}
